import { Injectable } from '@angular/core';
import {
  CalculateStrategyModel,
  EditableParam,
  PreparationModel
} from '@core/models/quotation-calculate';
import { QuotationDTO, QuotationParamsDTO } from '@core/modules/api/models';
import { QuotationCalculateHookService } from '@core/services/hooks/quotation-calculate-hook/quotation-calculate-hook.service';

@Injectable({
  providedIn: 'root'
})
export class QuotationCalculateHookCustomService extends QuotationCalculateHookService {
  constructor() {
    super();
  }

  getUpdateParams(options: {
    actualQuotation: QuotationDTO;
    entries: PreparationModel;
    strategy: CalculateStrategyModel;
    editingParam?: EditableParam;
  }): QuotationParamsDTO {
    if (
      options.strategy === 'amount-installment' &&
      options.editingParam === EditableParam.instalment
    ) {
      return {
        id: options.actualQuotation.tuplaId,
        installment: options.entries.installment,
        tan: options.actualQuotation.tan,
        financialTable: options.actualQuotation.financialTable
      };
    } else {
      return {
        id: options.actualQuotation.tuplaId,
        installment: options.entries.installment,
        tan: options.actualQuotation.tan,
        duration: options.entries.duration,
        amount: options.entries.amount,
        financialTable: options.actualQuotation.financialTable
      };
    }
  }
}
